/** Canonical native bundle product handles — one cart line, Shopify bundle pricing. */
(() => {
  const handles = [
    'ghalia-infinity-ring-duo',
    'knot-bridge-duo-silver',
    'knot-bridge-duo-gold',
    'ghalia-knot-hero-set-gold',
    'ghalia-knot-hero-set-silver',
    'ghalia-knot-two-tone-ring-stack',
    'ghalia-knot-wrist-story',
    'ghalia-pave-gold-stack',
    'ghalia-pave-silver-stack',
    'ghalia-cross-ring-earring-gold',
    'ghalia-duo-beads-set',
    'ghalia-front-drops-set',
    'ghalia-long-drops-set',
    'ghalia-duo-drops-set',
    'ghalia-long-short-set',
  ];
  window.GhaliaNativeBundleHandles = new Set(handles);
  window.GhaliaNativeBundleDiscounts = {
    'ghalia-infinity-ring-duo': 8,
    'knot-bridge-duo-silver': 8,
    'knot-bridge-duo-gold': 8,
    'ghalia-knot-hero-set-gold': 10,
    'ghalia-knot-hero-set-silver': 10,
    'ghalia-knot-two-tone-ring-stack': 8,
    'ghalia-knot-wrist-story': 8,
    'ghalia-pave-gold-stack': 10,
    'ghalia-pave-silver-stack': 10,
    'ghalia-cross-ring-earring-gold': 5,
    'ghalia-duo-beads-set': 16,
    'ghalia-front-drops-set': 22,
    'ghalia-long-drops-set': 22,
    'ghalia-duo-drops-set': 18,
    'ghalia-long-short-set': 23,
  };
  window.GhaliaNativeBundleAnchors = new Set([
    'infinity-bridge-ring',
    'single-infinity-pave-ring',
    'knot-bridge-ring-silver',
    'knot-bridge-bracelet-silver',
    'knot-bridge-bracelet-gold',
    'knot-bridge-ring-gold-1',
    'knot-bracelet-gold',
    'knot-bracelet-silver',
    'knot-ring-gold',
    'knot-ring-silver',
    'knot-hoop-earring-gold',
    'knot-hoop-earring-silver',
    'pave-dainty-ring-gold',
    'pave-initial-ring-gold',
    'pave-signet-ring-gold',
    'pave-dainty-ring-silver',
    'pave-initial-ring-silver',
    'pave-signet-ring-silver',
    'beads-studs-earrings-gold',
    'duo-studs-earrings',
    'drops-stones-studs-earrings',
    'front-drops-earrings',
    'long-drops-earrings',
    'short-drops-earrings',
  ]);
  /** Ordered component handles per bundle — option index maps to same index here. */
  window.GhaliaNativeBundleComponents = {
    'ghalia-infinity-ring-duo': ['infinity-bridge-ring', 'single-infinity-pave-ring'],
    'knot-bridge-duo-silver': ['knot-bridge-ring-silver', 'knot-bridge-bracelet-silver'],
    'knot-bridge-duo-gold': ['knot-bridge-ring-gold-1', 'knot-bridge-bracelet-gold'],
    'ghalia-knot-hero-set-gold': ['knot-bracelet-gold', 'knot-ring-gold', 'knot-hoop-earring-gold'],
    'ghalia-knot-hero-set-silver': ['knot-bracelet-silver', 'knot-ring-silver', 'knot-hoop-earring-silver'],
    'ghalia-knot-two-tone-ring-stack': ['knot-ring-gold', 'knot-ring-silver', 'knot-bridge-ring-gold-1'],
    'ghalia-knot-wrist-story': ['knot-bridge-bracelet-silver', 'knot-bracelet-gold'],
    'ghalia-pave-gold-stack': ['pave-dainty-ring-gold', 'pave-initial-ring-gold', 'pave-signet-ring-gold'],
    'ghalia-pave-silver-stack': [
      'pave-dainty-ring-silver',
      'pave-initial-ring-silver',
      'pave-signet-ring-silver',
    ],
    'ghalia-cross-ring-earring-gold': ['knot-hoop-earring-gold', 'pave-dainty-ring-gold'],
    'ghalia-duo-beads-set': ['beads-studs-earrings-gold', 'duo-studs-earrings'],
    'ghalia-front-drops-set': ['drops-stones-studs-earrings', 'front-drops-earrings'],
    'ghalia-long-drops-set': ['drops-stones-studs-earrings', 'long-drops-earrings'],
    'ghalia-duo-drops-set': ['drops-stones-studs-earrings', 'duo-studs-earrings'],
    'ghalia-long-short-set': ['long-drops-earrings', 'short-drops-earrings'],
  };
})();
